<!-- ToolBar -->
<mat-toolbar class="toolbar">
  <button mat-icon-button (click)="toolbarMenuButton()">
    <mat-icon>menu</mat-icon>
  </button>

  <img [src]="logoPath" alt="Sostenibile" class="logo-path" (click)="goToDashboard()" />

  <span class="toolbar-spacer"> </span>

  <div style="margin-right: 20px">
    <app-notifications></app-notifications>
  </div>

  <div class="label-azienda">
    <mat-form-field appearance="outline">
      <span matPrefix class="azienda-icon"><mat-icon>business</mat-icon></span>
      <mat-label>Azienda</mat-label>
      <mat-select
        #matSelect
        placeholder="Azienda"
        [(ngModel)]="azienda"
        (valueChange)="cambioAzienda($event)"
        [compareWith]="compareAzienda"
      >
        @for (azd of arrayAziende; track azd.id) {
          <mat-option class="label-azienda-option" [value]="azd">{{
            azd.ragioneSociale
          }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <button class="user-button" mat-stroked-button color="primary" [matMenuTriggerFor]="userMenu">
    <mat-icon>account_circle</mat-icon>
    <a style="font-weight: 500; color: black"> {{ infoUtente?.userDetails?.username }}</a>
  </button>
  <mat-menu #userMenu="matMenu" [xPosition]="'before'">
    <button class="btn-lista-menu" mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon> <span>Logout</span>
    </button>
  </mat-menu>
</mat-toolbar>

<!-- MENU LATERALE -->
<mat-sidenav-container autosize>
  <mat-sidenav
    #drawer
    class="mat-drawer"
    mode="side"
    [opened]="!isSidenavMini"
    [ngClass]="{ close: isSidenavMini, open: !isSidenavMini }"
  >
    <!--  <mat-sidenav #drawer class="drawer" mode="side" [opened]="!isSidenavMini" [class.close]="isSidenavMini">  -->

    <mat-nav-list class="menu">
      @for (voceMenu of vociMenu; track $index) {
        <!-- Menu principale -->
        @if (!voceMenu.sottoSezione?.length) {
          <mat-list-item
            matTooltipPosition="right"
            [matTooltip]="isSidenavMini ? voceMenu.sezione : undefined"
            [disabled]="voceMenu.disabled"
            (click)="azionaMenu(voceMenu)"
            [ngClass]="{ active: isRouteActive(voceMenu.fullPath) }"
          >
            <div class="cnt-icon-voce">
              <mat-icon class="icon-menu">{{ voceMenu.icon }}</mat-icon>

              @if (!isSidenavMini) {
                <span class="voce-menu">{{ voceMenu.sezione }}</span>
              }
            </div>
          </mat-list-item>
        }

        <!-- Menu con sotto-sezioni -->
        @if (voceMenu.sottoSezione?.length) {
          <mat-list-item
            matTooltipPosition="right"
            [matTooltip]="isSidenavMini ? voceMenu.sezione : undefined"
            [disabled]="voceMenu.disabled"
            (click)="toggleSubMenu($index, voceMenu)"
            style="margin-bottom: 0px !important"
          >
            <div class="cnt-icon-voce">
              <mat-icon class="icon-menu">{{ voceMenu.icon }}</mat-icon>
              @if (!isSidenavMini) {
                <span class="voce-menu">{{ voceMenu.sezione }}</span>
                <mat-icon style="margin-left: auto">{{
                  voceMenu.isExpanded ? 'expand_less' : 'expand_more'
                }}</mat-icon>
              }
            </div>
          </mat-list-item>

          <!--   @if (voceMenu.isExpanded) { -->
          <div class="submenu" [ngClass]="{ expanded: voceMenu.isExpanded }">
            @for (voceSottoMenu of voceMenu.sottoSezione; track $index) {
              <mat-list-item
                [ngClass]="{ active: isRouteActive(voceSottoMenu.fullPath) }"
                [disabled]="voceSottoMenu.disabled"
                (click)="azionaMenu(voceSottoMenu)"
              >
                <div class="cnt-icon-voce" style="padding-left: 20px">
                  <span style="transform: scale(1.3)">{{ voceSottoMenu.icon }}</span>
                  @if (!isSidenavMini) {
                    <span class="voce-menu">{{ voceSottoMenu.sezione }}</span>
                  }
                </div>
              </mat-list-item>
            }
          </div>
        }
      }
      <!--   } -->
    </mat-nav-list>
  </mat-sidenav>

  <!-- CONTENT DELLA PAGINA -->
  <mat-sidenav-content [class.close]="isSidenavMini">
    <ng-scrollbar>
      <router-outlet></router-outlet>
    </ng-scrollbar>
  </mat-sidenav-content>
</mat-sidenav-container>
